import { parseDate } from '../utils/formValue';

export default function initDateValidator() {
    // Replace jQuery's default date validator
    $.validator.addMethod("date", function (value, element) {
        if (!value) return true; // allow empty, use required for emptiness

        var date = parseDate(value);

        return date != null;
    });

}